/// \file assetManagementRoutes.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.


import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const AssetManagementList = lazy(() => import('../views/asset-management/list/view'));

async function assetManagementDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/asset-management/list/loader')).default;
  return actualLoader(args);
}

export async function assetManagementAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/asset-management/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="AssetManagement"
    handle={{
      text: 'Asset Management'
    }}
  >
    <Route
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <AssetManagementList />
        </Suspense>
      }
      loader={assetManagementDataLoader}
      action={assetManagementAction}
      />
  </Route>
);

export default routes;